import React from 'react';
import classnames from 'classnames';
import { Box, Typography } from '@lucid/lego';
import { formatCurrency, formatString } from '../../../../utils/tools';
import styles from './Price.module.scss';

type PriceProps = {
  label: string;
  value: number;
  currencyCode: string;
  theme: 'dark' | 'light';
  isBold?: boolean;
  isNegative?: boolean;
};

/**
 * Price component for displaying pricing breakdown
 * @component
 */
const Price: React.FC<PriceProps> = ({
  label,
  value,
  currencyCode,
  theme,
  isBold = false,
  isNegative = false,
}) => {
  const formattedLabel = formatString(label);

  return (
    <Box className={styles.priceRow}>
      <Typography
        className={classnames({ [styles.bold]: isBold })}
        variant="body"
        size={isBold ? 'medium' : 'small'}
        theme={theme}
      >
        {formattedLabel}
      </Typography>
      <Typography
        className={classnames({ [styles.bold]: isBold })}
        variant="body"
        size={isBold ? 'medium' : 'small'}
        theme={theme}
      >
        {isNegative && value > 0 ? '-' : ''}
        {formatCurrency(Math.abs(value), currencyCode)}
      </Typography>
    </Box>
  );
};

Price.displayName = 'Price';

export default Price;
